<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Lista Permessi
            </div>
            <div class="grid grid-cols-4 gap-4 mb-3">
                <div class="flex flex-col col-span-2">
                    <Field field_name="Cerca" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>
            </div>
            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_1`]>
                        {{ $filters.toDateTime(c.created_at) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_2`]>
                        {{ $filters.toDateTime(c.deleted_at) }}
                    </template>
                </NextTable>

            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri utenti.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Field from "@/components/Field.vue";
import Lista from "@/setup/ListaCerca";
import permessiManager from "@/api/Permessi";
import Paginator from "@/components/Paginator.vue";

@Options({
    name:'ListaPermessi',
    components: {
        Paginator,
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    }
})
export default class ListaPermessi extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    lista: any = setup(()=>Lista(permessiManager, this.cols))
    visible = false

    mounted() {
        this.lista.fetchData()
    }

    cols = [
        {
            name: 'Nome permesso',
            prop: 'name',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data creazione',
            prop: 'created_at',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data aggiornamento',
            prop: 'updated_at',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
    ]
}

</script>


<style lang="scss">

</style>
